export default __webpack_public_path__ + "static/impact-partnerships-4bce5148ffcc8c5edca6605c1e8975f4.jpg";